import { toast } from "sonner";

const ACTION_LABELS = {
  analytics_ask: "Pregunta IA",
  analytics_insights: "Insights IA",
  finance_insights_refresh: "Insights de finanzas",
  vision_shelf: "Análisis de estantería",
  social_copy: "Copy para redes",
  recipe_gen: "Receta generada",
  menu_gen: "Menú generado",
  menu_import: "Menú importado",
  forecast: "Previsión de ventas",
  invoice_extract: "Factura procesada",
  brand_ambiance: "Ambiance de marca",
  website_content: "Contenido web",
  waste_estimate: "Estimación de mermas",
  allergen_ai: "Análisis de alérgenos",
  image_gen_dish: "Imagen de plato",
  image_gen_ingredient: "Imagen de ingrediente",
  image_gen_logo: "Logo generado",
};

/**
 * Show a small "✓ deducted N cr · M left" toast after a successful AI call.
 * Pass the receipt dict that arrives in the response body under the key
 * ``_credits_receipt`` (null when the user is grandfathered or no charge
 * happened — in which case this helper silently no-ops).
 *
 * A low "alert" in the receipt.remaining (<=10% left, tuned client-side)
 * bumps the severity to a warning toast instead of info so the user
 * notices they're running low.
 */
export function showCreditReceipt(receipt) {
  if (!receipt || receipt.deducted == null || receipt.remaining == null) return;

  // Respect a user-level opt-out. Default ON.
  if (typeof window !== "undefined" &&
      window.localStorage?.getItem("mg_hide_credit_receipts") === "1") {
    return;
  }

  const label = ACTION_LABELS[receipt.action] || "Acción IA";
  const runningLow = receipt.remaining >= 0 && receipt.remaining < 20;
  const description = `Te quedan ${receipt.remaining} créditos`;

  const opts = { duration: 3000, description };
  if (runningLow) {
    toast.warning(`${label} · -${receipt.deducted} cr`, {
      ...opts, duration: 5000,
    });
  } else {
    toast.success(`${label} · -${receipt.deducted} cr`, opts);
  }
}

export default showCreditReceipt;
